import React, { Component } from "react";
import axios from "axios";

import { connect } from "react-redux";
import { withRouter } from "react-router";
import { withFirebase } from "../../../firebase";
import { sushizoomAPI } from "../../../api/sushizoomAPI";

import Banners from "./index";

class BannersContainer extends Component {
	constructor() {
		super();

		this.state = {
			preloader: false,
			allBanners: [],
			banners: [],
			images: [],
		};
	}

	componentDidMount() {
		this.getBanners();
	}

	setImages = (images) => this.setState({ images });
	setBanners = (banners) => this.setState({ banners });

	mapBannerToView = (banner, index) => ({
		available:
			banner && banner.available !== undefined
				? !!banner.available
				: !!(banner && banner.isAvailable),
		photo:
			(banner && (banner.photo || banner.smallPhoto || banner.largePhoto)) || "",
		smallPhoto:
			(banner && (banner.smallPhoto || banner.photo || banner.largePhoto)) || "",
		largePhoto:
			(banner && (banner.largePhoto || banner.photo || banner.smallPhoto)) || "",
		order:
			banner && banner.order !== undefined
				? String(banner.order)
				: String(index + 1),
		title: (banner && banner.title) || "",
		description: (banner && banner.description) || "",
		productsId: (banner && banner.productsId) || [""],
	});

	mapViewToBanner = (banner, index) => ({
		description: (banner && banner.description) || "",
		isAvailable:
			banner && banner.available !== undefined
				? !!banner.available
				: !!(banner && banner.isAvailable),
		largePhoto:
			(banner && (banner.largePhoto || banner.photo || banner.smallPhoto)) || "",
		order:
			banner && banner.order !== undefined
				? String(banner.order)
				: String(index + 1),
		productsId: (banner && banner.productsId) || [""],
		smallPhoto:
			(banner && (banner.smallPhoto || banner.photo || banner.largePhoto)) || "",
		title: (banner && banner.title) || "",
	});

	normalizeBannersOrder = (banners) =>
		[...(banners || [])]
			.sort((a, b) => Number(a.order || 0) - Number(b.order || 0))
			.map((banner, index) => ({
				...banner,
				order: String(index + 1),
			}));

	getBanners = async () => {
		this.setState({ preloader: true });
		const response = await sushizoomAPI.getBanners();
		const array = Array.isArray(response) ? response : [];
		const normalized = this.normalizeBannersOrder(array);
		const banners = normalized.map(this.mapBannerToView);
		this.setState({ banners, allBanners: banners, preloader: false });
	};

	saveBanners = async (data, options = {}) => {
		const { showSuccessAlert = false } = options;
		const banners = this.normalizeBannersOrder(
			(data || []).map(this.mapViewToBanner)
		);
		const response = await sushizoomAPI.saveBanners(banners);

		if (!response || !response.ok) {
			const errorText =
				(response && response.error) ||
				"Не удалось сохранить баннеры (write token required)";
			console.error("Ошибка сохранения баннеров:", errorText);
			alert(errorText);
			return false;
		}

		if (showSuccessAlert) {
			alert("Баннеры успешно сохранены");
		}
		return true;
	};

	deleteBanner = ({ id, data, name }) => {
		console.log("delete banners!", data, id);

		const sendData = [...data];

		fetch(`https://e-admin.com.ua/photo/deleteBanner.php`, {
			method: "POST",
			body: JSON.stringify({
				id,
				name,
				login: this.props.login,
				folder: "loyalty-system",
			}),
		})
			.then((response) => {
				if (!response.ok && response.status !== 200) {
					throw new Error("Ошибка запроса!");
				}

				return this.saveBanners(sendData);
			})
			.then((saved) => {
				if (!saved) return;
				const normalized = this.normalizeBannersOrder(sendData);
				const nextView = normalized.map(this.mapBannerToView);
				this.setState({
					images: nextView,
					banners: nextView,
					allBanners: nextView,
				});
				setTimeout(() => alert(`Фото ${name} - было удалено!`), 100);
			})
			.catch((error) => {
				console.log("error", error);
			});
	};

	saveText = (text, id) => {
		console.log("--- saveText --- text id", text, id);
		try {
			const data = [...this.state.banners];
			if (data[id]) {
				data[id] = { ...data[id], description: text };
				this.saveBanners(data).then((saved) => {
					if (saved) this.getBanners();
				});
			}
		} catch (err) {
			console.log("Ошибка записи текста!", err);
		}
	};

	sendData = (data) => {
		console.log("onSubmit data", data);

		let self = this;
		let isUpload = false;
		let isDnD = false;

		for (let key in data) {
			if (data[key].upload) isUpload = true;
			if (data[key].dnd) isDnD = true;
		}

		if (!isUpload && !isDnD) {
			let banners = [...data];

			self.saveBanners(banners, { showSuccessAlert: true })
				.then((saved) => {
					if (!saved) return;
					self.getBanners();
					console.log("success set data", banners);
				})
				.catch((error) => {
					console.error(error);
				});
		}

		if (isUpload) {
			console.log("--- uploading ---");

			let uploadData = [];

			for (let key in data) {
				let {
					available,
					isAvailable,
					order,
					title,
					description,
					productsId,
					smallPhoto,
					largePhoto,
					photo,
				} = data[key];

				if (data[key].upload) {
					uploadData.push({
						available:
							available !== undefined
								? !!available
								: isAvailable !== undefined
								? !!isAvailable
								: true,
						isAvailable:
							isAvailable !== undefined
								? !!isAvailable
								: available !== undefined
								? !!available
								: true,
						order,
						title: title || "",
						description: description || "",
						productsId: productsId || [""],
						smallPhoto: smallPhoto || photo || "",
						largePhoto: largePhoto || photo || "",
						photo: photo || smallPhoto || largePhoto || "",
					});
				}
			}

			let isFetchOK = false;

			function uploadPhoto(file, key) {
				return axios
					.post(`https://e-admin.com.ua/photo/index.php`, file)
					.then((res) => {
						if (res && res.data && res.data.image_name) {
							const namePhoto = res.data.image_name.split(" ")[0];

							if (namePhoto && self.props.login) {
								isFetchOK = true;
								const photo = `https://e-admin.com.ua/photo/photo/uploads/${self.props.login}/loyalty-system/${namePhoto}`;
								uploadData[key].photo = photo;
								uploadData[key].smallPhoto = photo;
								uploadData[key].largePhoto = photo;
							} else {
								isFetchOK = false;
								throw new Error("Неверные данные логина или названия изображения");
							}
						}
					})
					.catch((error) => {
						console.error("Ошибка загрузки изображения", error);
						self.setState({ preloader: false });
					});
			}

			async function uploadAll() {
				for (let key in uploadData) {
					let item = data[key];

					if (item.file && self.props.login) {
						let file = new FormData();
						file.append("photo", item.file);
						file.append("login", self.props.login);
						file.append("folder", "loyalty-system");

						await uploadPhoto(file, key);
					}
				}
				return { status: true };
			}

			uploadAll()
				.then((response) => {
					if (!response || !response.status) {
						throw new Error("Ошибка загрузки баннера");
					}

					uploadData = isFetchOK
						? [...this.state.banners, ...uploadData]
						: this.state.banners;

					self.saveBanners(uploadData, { showSuccessAlert: true }).then((saved) => {
						if (saved) self.getBanners();
					});
					this.setState({ images: [] });
				})
				.catch((error) => {
					alert("Ошибка при загрузке банеров", error);
				});
		}

		if (isDnD) {
			console.log("--- Drag and Drop ---");

			let dndData = [];

			for (let key in data) {
				let {
					available,
					isAvailable,
					photo,
					smallPhoto,
					largePhoto,
					order,
					title,
					description,
					productsId,
				} = data[key];

				if (data[key].dnd) {
					dndData.push({
						...data[key],
						available:
							available !== undefined
								? !!available
								: isAvailable !== undefined
								? !!isAvailable
								: true,
						isAvailable:
							isAvailable !== undefined
								? !!isAvailable
								: available !== undefined
								? !!available
								: true,
						order,
						photo: photo || smallPhoto || largePhoto,
						smallPhoto: smallPhoto || photo || largePhoto,
						largePhoto: largePhoto || photo || smallPhoto,
						title: title || "",
						description: description || "",
						productsId: productsId || [""],
					});
				}
			}

			let sendData = [...dndData];

			self.saveBanners(sendData, { showSuccessAlert: true })
				.then((saved) => {
					if (!saved) return;
					self.getBanners();
					console.log("success set dnd data", sendData);
				})
				.catch((error) => {
					console.error(error);
				});
		}
	};

	render() {
		return (
			<>
				<Banners
					getImages={this.getBanners}
					onSubmit={this.sendData}
					saveText={this.saveText}
					deleteBanner={this.deleteBanner}
					loadStatus={this.state.preloader}
					banners={this.state.banners}
					allBanners={this.state.allBanners}
					images={this.state.images}
					setImages={this.setImages}
					setBanners={this.setBanners}
				/>
			</>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		login: state.auth.login,
	};
};

export default connect(mapStateToProps, null)(withRouter(withFirebase(BannersContainer)));
